import chroma from "chroma-js";

export const eventSelectStyles = (customColors) => {
  return {
    menuPortal: (styles) => ({
      ...styles,
      zIndex: 99999,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      const color = data.color && customColors ? chroma(data.color) : "";
      if (!color) {
        return {
          ...styles,
        };
      }
      return {
        ...styles,
        backgroundColor: isDisabled
          ? null
          : isSelected
          ? data.color
          : isFocused
          ? color.alpha(0.1).css()
          : null,
        color: isDisabled
          ? "#ccc"
          : isSelected
          ? chroma.contrast(color, "black") < 7
            ? "white"
            : "black"
          : data.color,
        cursor: isDisabled ? "not-allowed" : "default",

        ":active": {
          ...styles[":active"],
          backgroundColor:
            !isDisabled && (isSelected ? data.color : color.alpha(0.3).css()),
        },
      };
    },
    multiValue: (styles, { data }) => {
      const color = data.color && customColors ? chroma(data.color) : "";
      if (!color) {
        return {
          ...styles,
        };
      }
      return {
        ...styles,
        backgroundColor: color.alpha(0.1).css(),
      };
    },
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "#b71d1a",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "#b71d1a",
        color: "white",
      },
    }),
  };
};
